module.exports = __webpack_public_path__ + "static/media/LikeButton.160f080f.svg";